$(document).ready(function() {
  // Function to handle active state and image display for each menu
  function handleMenu(menuId) {
    // Set the first item as active by default for this menu
    var firstItem = $('#' + menuId + ' .collection-item').first();
    firstItem.addClass('active');

    // Display the corresponding image for the first item
    var firstCollectionHandle = firstItem.data('collection-handle');
    $('#' + menuId + ' .collection-img').each(function() {
      if ($(this).hasClass('collection-img-' + firstCollectionHandle)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    // On hover, update the active state and show corresponding image for the hovered item
    $('#' + menuId + ' .collection-item').hover(function() {
      // Remove active state from all items in this menu
      $('#' + menuId + ' .collection-item').removeClass('active');
      $(this).addClass('active');
      
      // Show the corresponding image for the hovered item
      var collectionHandle = $(this).data('collection-handle');
      $('#' + menuId + ' .collection-img').each(function() {
        if ($(this).hasClass('collection-img-' + collectionHandle)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });

    // Optional: Keep the image visible when you leave the hover state (hover off)
    $('#' + menuId + ' .collection-item').mouseleave(function() {
      $(this).removeClass('active');
      // You can make the first collection image visible again if desired
    });
  }

  // Handle first menu (select_menu_pTyfbX)
  handleMenu('select_menu_pTyfbX');

  // Handle second menu (select_menu_Wz4zHF)
  handleMenu('select_menu_Wz4zHF');
}); 

$(document).ready(function() {
  // Handle click on menu items
  $('.mobile-mega-menu li').click(function(e) {
    e.preventDefault();

    var targetId = $(this).attr('id');
    var targetBox = $('#' + targetId + '.mega-menu.collc-box');
    var mobileMenu = $('.nws-custom-mobile-menu');

    if (targetBox.hasClass('active')) {
      targetBox.removeClass('active');
      mobileMenu.removeClass('active');
    } else {
      $('.mega-menu.collc-box').removeClass('active');
      targetBox.addClass('active');

      mobileMenu.addClass('active');
    }
  });

  // Close menu when h4 inside is clicked
  $('.mega-menu.collc-box .collection-list h4').click(function(e) {
    var parentBox = $(this).closest('.mega-menu.collc-box');
    parentBox.removeClass('active');
    $('.nws-custom-mobile-menu').removeClass('active');
  });
});


jQuery(document).ready(function () {
    jQuery(".collection-prod .load-post").slice(0, 9).show();
  
    if (jQuery(".collection-prod .load-post").length <= 9) {
        jQuery(".loadMore").hide();
    }
    jQuery(".loadMore").on('click', function (e) {
        e.preventDefault();

        let hiddenPosts = jQuery(".collection-prod .load-post:hidden").slice(0, 4);
        hiddenPosts.slideDown();

        if (jQuery(".collection-prod .load-post:hidden").length == 0) {
            jQuery(".loadMore").fadeOut('slow');
        }

        if (hiddenPosts.length > 0) {
            jQuery('html, body').animate({
                scrollTop: hiddenPosts.first().offset().top - 100
            }, 800);
        }
    });
});

jQuery('.prod-slide').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToScroll: 1,

    responsive: [{
        breakpoint: 993,
        settings: {
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1
        }
    }, 

    {
      breakpoint: 768,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 2,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 601,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 481,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }]
}); 

function initMobileSlider() {
    var winWidth = $(window).width();

    // Initialize/Destroy icon-slide-mob for <= 767px
    if (winWidth <= 767) {
        if (!$('.icon-slide-mob').hasClass('slick-initialized')) {
            $('.icon-slide-mob').slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                autoplay: false
            });
        }
    } else {
        if ($('.icon-slide-mob').hasClass('slick-initialized')) {
            $('.icon-slide-mob').slick('unslick');
        }
    }

    // Initialize/Destroy mobile-prod-slide for >= 992px
    if (winWidth <= 900) {
        if (!$('.mobile-prod-slide').hasClass('slick-initialized')) {
            $('.mobile-prod-slide').slick({
                dots: true,
                arrows: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                autoplay: false,
                 nextArrow: `<button type="button" class="slick-next">
                <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.921173 1L3.8418 3.92062L0.921173 6.84125" stroke="black" stroke-width="0.730156" stroke-linecap="round"/>
                </svg>
            </button>`,
            prevArrow: `<button type="button" class="slick-prev">
                <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
                    <path d="M0.921173 1L3.8418 3.92062L0.921173 6.84125" stroke="black" stroke-width="0.730156" stroke-linecap="round"/>
                </svg>
            </button>`
            });
        }
    } else {
        if ($('.mobile-prod-slide').hasClass('slick-initialized')) {
            $('.mobile-prod-slide').slick('unslick');
        }
    }
}

$(document).ready(function () {
    initMobileSlider();
});

$(window).on('resize', function () {
    initMobileSlider();
});


 (function() {
 Wishlist.init();
}());


$(".faq-item").click(function() {
// Toggle the answer when clicking on a question
$(this).find(".faq-answer").slideToggle(300);

// Close other answers
$(".faq-item").not(this).find(".faq-answer").slideUp(300);
});  

jQuery('.faq-list .accordion-item').click(function(){
  if( jQuery(this).hasClass('active-drop') ) {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
  } else {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
      jQuery(this).addClass('active-drop');
  }
});
 
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.accordion-item');

  items.forEach(item => {
    const header = item.querySelector('.accordion-header');

    header.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Close all
      items.forEach(i => {
        i.classList.remove('active');
        i.querySelector('.icon').textContent = '+';
      });

      // Open clicked
      if (!isActive) {
        item.classList.add('active');
        item.querySelector('.icon').textContent = '−';
      }
    });
  });
}); 

$(document).ready(function() {
    $.getJSON('/cart.js', function(cart) {
        // Cart items ki total quantity ko calculate karna
        var totalItems = 0;
        $.each(cart.items, function(index, item) {
            totalItems += item.quantity;
        });

        // Total items count ko display karna
        $('#total-items-count').text(totalItems);
    });
});

 // Open Sidebar
$(".nws-icon-open").click(function () {
    $(".nws-custom-mobile-menu").addClass("open");
    $(".nws-custom-mobile-overlay").addClass("menu-sidebar-active");
});

// Close Sidebar
$(".menu-toggle-close").click(function () {
    $(".nws-custom-mobile-menu").removeClass("open");
    $(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
});

// Close sidebar when clicking outside
$(document).click(function (event) {
    if (!$(event.target).closest(".nws-custom-mobile-menu, .nws-icon-open").length) {
        $(".nws-custom-mobile-menu").removeClass("open");
        $(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
    }
});

function toggleHeaderClass() {
    if (jQuery(window).scrollTop() > 60) {
        jQuery(".nws-header").addClass("fix_head");
    } else {
        jQuery(".nws-header").removeClass("fix_head");
    }
}

// Run on scroll
jQuery(window).on("scroll", toggleHeaderClass);

// Run on page load
jQuery(document).ready(function() {
    toggleHeaderClass();
});


$(document).ready(function(){
  $('.tab-title').on('click', function(){
    var currentSection = $(this).closest('.foo-toggle');
    
    // If the current section is not active, close all others first
    if (!currentSection.hasClass('active')) {
      $('.foo-toggle.active').removeClass('active')
                              .find('ul.list-unstyled').slideUp();
      
      // Then open the clicked section
      currentSection.addClass('active')
                    .find('ul.list-unstyled').slideDown();
    } else {
      // If it's already active, close it
      currentSection.removeClass('active')
       .find('ul.list-unstyled').slideUp();
    }
  });
}); 

 jQuery('.slide-testimonial').slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        responsive: [
         {
          breakpoint: 1171,
          settings: {
              dots: false,
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1
          }
         },{
            breakpoint: 1050,
            settings: {
                dots: false,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },{
            breakpoint: 800,
            settings: {
                dots: false,
                arrows: false, 
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '60px',
            }
        },{
        breakpoint: 600,
        settings: {
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '60px',
        }
    }]
  });


$(document).ready(function () {
  var $sliderFor = $('.slider-for');
  var $sliderNav = $('.slider-nav');
  var $mobileThumbs = $('.nws_custom-thumbnails');
  var $mobileFeatured = $('.nws_custom-featured');
  var navSlider = null;
  // ✅ Desktop Slick Initialization
  if ($sliderFor.length && $sliderNav.length) {
    $sliderFor.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav',
    });
    $sliderNav.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      arrows: true,
      vertical: true,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="slick-prev thumb-arrow">↑</button>',
      nextArrow: '<button type="button" class="slick-next thumb-arrow">↓</button>',
    });
    navSlider = $sliderNav.slick('getSlick');
    function updateThumbArrows(currentSlide, totalSlides, slidesToShow) {
      const $prevArrow = $('.slider-nav .slick-prev');
      const $nextArrow = $('.slider-nav .slick-next');
      if (currentSlide === 0) {
        $prevArrow.hide();
        $nextArrow.show();
      } else if (currentSlide >= totalSlides - slidesToShow) {
        $prevArrow.show();
        $nextArrow.hide();
      } else {
        $prevArrow.show();
        $nextArrow.show();
      }
    }
    updateThumbArrows(0, navSlider.slideCount, navSlider.options.slidesToShow);
    $sliderNav.on('afterChange', function (event, slick, currentSlide) {
      updateThumbArrows(currentSlide, slick.slideCount, slick.options.slidesToShow);
    });
  }
  // ✅ Mobile Slick Initialization
  if ($mobileThumbs.length && $mobileFeatured.length) {
    $mobileThumbs.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.nws_custom-featured'
    });
    $mobileFeatured.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.nws_custom-thumbnails',
      dots: false,
      arrows: true,
      centerPadding: '40px',
      focusOnSelect: true
    });
  }
  // ✅ Variant Click Handler for Both Views
  $('.variant-option').on('click', function () {
    var $this = $(this);
    var variantId = $this.data('variant-id');
    var variantImage = $this.data('image');
    var optionName = $this.data('option-name').toLowerCase();
    var optionValue = $this.data('option-value');
    // Update selected option text
    $('#selected-' + optionName).text(optionValue);
    // Styling update
    $this
      .addClass('active border-black')
      .removeClass('border-transparent')
      .siblings()
      .removeClass('active border-black')
      .addClass('border-transparent');
    // Update hidden variant input
    $('input[name="id"]').val(variantId);
    // ✅ Desktop Image Update
    if ($sliderFor.length && $sliderNav.length && navSlider !== null) {
      var desktopIndex = -1;
      $('#featured-slider .gallery-item img').each(function (index) {
        var galleryImage = $(this).attr('src');
        if (galleryImage.split('?')[0] === variantImage.split('?')[0]) {
          desktopIndex = index;
          return false;
        }
      });
      if (desktopIndex !== -1) {
        $sliderFor.slick('slickGoTo', desktopIndex);
        $sliderNav.slick('slickGoTo', desktopIndex);
        updateThumbArrows(desktopIndex, navSlider.slideCount, navSlider.options.slidesToShow);
      }
    }
    // ✅ Mobile Image Update (Thumbnail Slider = Featured Image)
    if ($mobileThumbs.length) {
      var mobileIndex = -1;
      $('.nws_custom-thumbnails .gallery-item img').each(function (index) {
        var galleryImage = $(this).attr('src');
        if (galleryImage.split('?')[0] === variantImage.split('?')[0]) {
          mobileIndex = index;
          return false;
        }
      });
      if (mobileIndex !== -1) {
        $mobileThumbs.slick('slickGoTo', mobileIndex);
        $mobileFeatured.slick('slickGoTo', mobileIndex);
      }
    }
  });
  // ✅ Trigger first variant on load
  $('.variant-option').first().trigger('click');
});

 
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM Content Loaded - Initializing video players"); 
  const videoWrappers = document.querySelectorAll(".custom-video-wrapper");
  console.log(`Found ${videoWrappers.length} video wrappers`); 
  videoWrappers.forEach((wrapper, index) => {
    console.log(`Processing wrapper ${index + 1}`); 
    const video = wrapper.querySelector("video");
    const button = wrapper.querySelector(".play-pause-btn"); 
    if (!video) {
      console.error(`Video not found in wrapper ${index + 1}`);
      return;
    } 
    if (!button) {
      console.error(`Button not found in wrapper ${index + 1}`);
      return;
    } 
    console.log(`Video ${index + 1} initialized successfully`); 
    // Add video ready state check
    const initializeVideo = () => {
      console.log(`Video ${index + 1} ready state: ${video.readyState}`); 
      button.addEventListener("click", function () {
        console.log(`Button clicked for video ${index + 1}`); 
        // Pause all other videos first
        videoWrappers.forEach((otherWrapper, otherIndex) => {
          if (otherIndex !== index) {
            const otherVideo = otherWrapper.querySelector("video");
            const otherButton = otherWrapper.querySelector(".play-pause-btn");
            if (otherVideo && !otherVideo.paused) {
              otherVideo.pause();
              if (otherButton) {
                otherButton.classList.remove("playing");
              }
            }
          }
        }); 
        // Toggle the current video
        if (video.paused) {
          console.log(`Playing video ${index + 1}`);
          video.play().then(() => {
            console.log(`Video ${index + 1} started playing`);
            button.classList.add("playing");
          }).catch((error) => {
            console.error(`Video ${index + 1} play failed:`, error);
          });
        } else {
          console.log(`Pausing video ${index + 1}`);
          video.pause();
          button.classList.remove("playing");
        }
      }); 
      video.addEventListener("ended", () => {
        console.log(`Video ${index + 1} ended`);
        button.classList.remove("playing");
      }); 
      // Add error handling
      video.addEventListener("error", (e) => {
        console.error(`Video ${index + 1} error:`, e);
      }); 
      // Add loadeddata event to ensure video is ready
      video.addEventListener("loadeddata", () => {
        console.log(`Video ${index + 1} data loaded`);
      });
    }; 
    // Check if video is already loaded
    if (video.readyState >= 2) {
      initializeVideo();
    } else {
      video.addEventListener("loadedmetadata", initializeVideo);
    }
  });
}); 
// Alternative initialization method if DOMContentLoaded doesn't work
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeVideoPlayers);
} else {
  initializeVideoPlayers();
} 
function initializeVideoPlayers() {
  // Your existing code here as backup
  console.log("Backup initialization triggered");
}
  
$(document).ready(function () {
  // Automatically select first variant of each option
  $('.variant_block_wrapper').each(function () {
    $(this).find('div[data-option-name]').first().trigger('click');
  }); 
  $('.variant_block_wrapper div[data-option-name]').on('click', function () {
      var optionName = $(this).data('option-name').toLowerCase();
      var optionValue = $(this).data('option-value');
      var newImage = $(this).data('image'); 
      
      $('#selected-' + optionName).text(optionValue); 
      
      $(this).siblings().removeClass('border-black').addClass('border-transparent');
      $(this).removeClass('border-transparent').addClass('border-black'); 
      
      if (newImage) {
        $('[data-media-id] img').first().attr('src', newImage);
      } 
   });

}); 

$(document).ready(function () {

  // ✅ 1. Set default variant on page load
  var $defaultOption = $('.mo-variant-opt option:first');
  if ($defaultOption.length) {
    var defaultVal = $defaultOption.data('opt');
    var defaultID = $defaultOption.val();

    // Set active on matching variant options
    if (defaultVal) {
      // Loop through option segments (split if needed)
      $('.variant-option').each(function () {
        var opt1 = ($(this).data('option-p1') || '').toString().toLowerCase();
        var opt2 = ($(this).data('option-p2') || '').toString().toLowerCase();
        var opt3 = ($(this).data('option-p3') || '').toString().toLowerCase();

        var key = [opt1, opt2, opt3].filter(Boolean).join('');
        if (key === defaultVal) {
          $(this).addClass('active');
        }
      });
    }

    // Set select and hidden input
    $('.mo-variant-opt').val(defaultID);
    $('.product-variant-id').val(defaultID);
  }

  // ✅ 2. On click, update variant selection
  $('.variant-option').on('click', function () {
    // Update active state
    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    // Collect active options
    var optionP1 = ($('.variant-option1.active').data('option-p1') || '').toString().toLowerCase();
    var optionP2 = ($('.variant-option2.active').data('option-p2') || '').toString().toLowerCase();
    var optionP3 = ($('.variant-option3.active').data('option-p3') || '').toString().toLowerCase();

    var val = [optionP1, optionP2, optionP3].filter(Boolean).join('');

    var $matchedOption = $('.mo-variant-opt option[data-opt="' + val + '"]');
    var variantID = $matchedOption.val();

    setTimeout(function () {
      if (variantID) {
        $('.mo-variant-opt').val(variantID).trigger('change');
        $('.product-variant-id').val(variantID);
      }
    }, 500);
  });

});

 